module.exports = __webpack_public_path__ + "static/media/ebs.d9bc908d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/ebs.png
// module id = 401
// module chunks = 0